import { Directive, HostBinding, HostListener, Input } from '@angular/core'
import { DraggableOptions } from './draggable-options'
import { DragService } from './drag.service'

@Directive({
  selector: '[appdraggable]'
})
export class DraggableDirective {
  constructor(private dragService: DragService) {
  }

  @HostBinding('draggable')
  get draggable() {
    return true
  }

  @Input()
  set appdraggable(options: DraggableOptions) {
    if (options) {
      this.options = options
    }
  }

  private options: DraggableOptions = {}

  @HostListener('dragstart', ['$event'])
  onDragStart(event) {
    const {zone = 'zone', data = {}} = this.options

    this.dragService.startDrag(zone)

    event.dataTransfer.setData('Text', JSON.stringify(data))
  }
}




// WEBPACK FOOTER //
// ./src/app/shared/dnd/draggable.directive.ts